import axios from "axios";
import { EMPLOYEE_DASHBOARD_API_URL } from "../../api_helper";

axios.interceptors.request.use((req) => {
    if (localStorage.getItem("access")) {
        req.headers.Authorization = `Bearer ${JSON.parse(localStorage.getItem("access")).access_token}`;
    }
    return req;
});

axios.defaults.headers.common["Accept"] = "application/json";
axios.defaults.headers.common["Content-Type"] = "application/json";

// Create A Trailer
export const add_trailer_api = (formData) =>
  axios.post(EMPLOYEE_DASHBOARD_API_URL + "trailers/add_trailer", formData, { withCredentials: false });
